import { SxProperties } from '@bvi/mui-theme';

export const styles = {
  wrapper: {
    marginTop: '16px',
  },
  canvasWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 20px 12px',
    overflow: 'visible',
    '& > canvas': {
      width: '100%!important',
      height: '320px!important',
    },
  },
  canvasSkeleton: {
    minHeight: '320px',
    width: '100%',
  },
} satisfies SxProperties;
